import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import { Box, debounce, Divider, Grid, TextField, Typography } from "@mui/material";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { HeaderFiltro } from "../header-filtro";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";
import { theme } from "../../../../../../styles";

// Ajuste: Tornando NumberFormatCustom compatível com forwardRef
const NumberFormatCustom = forwardRef(function NumberFormatCustom(props: any, ref) {
    return <NumericFormat {...props} getInputRef={ref} />;
});

export const FiltroRendaPresumida = () => {
    // State
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
    // Hook
    const {
        setMaxRendaAnualFilter,
        setMaxRendaMensalFilter,
        setMinRendaAnualFilter,
        setMinRendaMensalFilter,
        resetRendaAnualFilter,
        resetRendaMensalFilter
    } = useProjetosService();

    return (
        <>
            <HeaderFiltro titulo="Renda Presumida"
                descricao={<>
                    <Typography>
                        Esta opção permite buscar pessoas pela renda mensal ou anual.
                    </Typography>
                    <Typography style={{ marginBottom: '10px' }}>
                        É possível selecionar um valor inicial e/ou final. Não é obrigatório selecionar os dois.
                    </Typography>
                    <Typography>
                        Caso nenhuma opção seja selecionada, consideraremos todo volume de renda.
                    </Typography>
                </>}
            />

            <Box p={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h6" color="primary" fontWeight="bold" textTransform={"uppercase"}>
                            Renda Mensal
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={filtrosSelecionados?.rendaPresumidaMensal?.min ?? ''}
                            InputProps={{
                                startAdornment: <span style={{ marginRight: '5px' }}>R$</span>,
                                inputComponent: NumberFormatCustom, // Agora compatível com forwardRef
                            }}
                            onChange={debounce((e) => {
                                const regexValue = e.target.value.replace(/\D/g, '');
                                if (regexValue.length === 0) {
                                    setMinRendaMensalFilter(undefined);
                                    return;
                                }

                                setMinRendaMensalFilter(Number(regexValue));
                                if (filtrosSelecionados?.rendaPresumidaAnual?.max || filtrosSelecionados?.rendaPresumidaAnual?.min) {
                                    resetRendaAnualFilter();
                                }
                            }, 200)}
                            label="Renda mensal mínima"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            InputProps={{
                                startAdornment: <span style={{ marginRight: '5px' }}>R$</span>,
                                inputComponent: NumberFormatCustom, // Agora compatível com forwardRef
                            }}
                            value={filtrosSelecionados?.rendaPresumidaMensal?.max ?? ''}
                            onChange={debounce((e) => {
                                const regexValue = e.target.value.replace(/\D/g, '');
                                if (regexValue.length === 0) {
                                    setMaxRendaMensalFilter(undefined);
                                    return;
                                }

                                setMaxRendaMensalFilter(Number(regexValue));
                                if (filtrosSelecionados?.rendaPresumidaAnual?.max || filtrosSelecionados?.rendaPresumidaAnual?.min) {
                                    resetRendaAnualFilter();
                                }
                            }, 200)}
                            label="Renda mensal máxima"
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider color={theme.palette.primary.main} sx={{ my: 3 }} />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" color="primary" fontWeight="bold" textTransform={"uppercase"}>
                            Renda Anual
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={filtrosSelecionados?.rendaPresumidaAnual?.min ?? ''}
                            InputProps={{
                                startAdornment: <span style={{ marginRight: '5px' }}>R$</span>,
                                inputComponent: NumberFormatCustom, // Agora compatível com forwardRef
                            }}
                            onChange={debounce((e) => {
                                const regexValue = e.target.value.replace(/\D/g, '');
                                if (regexValue.length === 0) {
                                    setMinRendaAnualFilter(undefined);
                                    return;
                                }

                                setMinRendaAnualFilter(Number(regexValue));
                                if (filtrosSelecionados?.rendaPresumidaMensal?.max || filtrosSelecionados?.rendaPresumidaMensal?.min) {
                                    resetRendaMensalFilter();
                                }
                            }, 200)}
                            label="Renda anual mínima"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            InputProps={{
                                startAdornment: <span style={{ marginRight: '5px' }}>R$</span>,
                                inputComponent: NumberFormatCustom, // Agora compatível com forwardRef
                            }}
                            value={filtrosSelecionados?.rendaPresumidaAnual?.max ?? ''}
                            onChange={(e) => {
                                const regexValue = e.target.value.replace(/\D/g, '');
                                if (regexValue.length === 0) {
                                    setMaxRendaAnualFilter(undefined);
                                    return;
                                }

                                setMaxRendaAnualFilter(Number(regexValue));
                                if (filtrosSelecionados?.rendaPresumidaMensal?.max || filtrosSelecionados?.rendaPresumidaMensal?.min) {
                                    resetRendaMensalFilter();
                                }
                            }}
                            label="Renda anual máxima"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};
